import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/follow.svg';

export const IconFollow = createIconComponent(Icon);
